export const messages = {
  en: {
    productManage: {
      title: 'Product Management',
      queryCondition: 'Query Conditions',
      productInfo: 'Product Information',
      productId: 'Product ID',
      productImage: 'Product Image',
      productGroup: 'Product Group',
      productName: 'Product Name',
      warehouse: 'Warehouse',
      sales: 'Sales',
      stock: 'Stock',
      price: 'Price',
      sort: 'Sort',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      label: 'Label',
      detail: 'Detail',
      addProduct: 'Add Product',
      export: 'Export',
      search: 'Search',
      reset: 'Reset',
      confirmDelete: 'Confirm Delete',
      deleteContent: 'Are you sure to delete this product?',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    productLabel: {
      title: 'Product Label',
      selectLabel: 'Select Label',
      save: 'Save'
    },
    productSpec: {
      title: 'Product Specification',
      specId: 'Spec ID',
      specName: 'Spec Name',
      select: 'Select',
      searchPlaceholder: 'Input spec name'
    }
  },
  zh: {
    productManage: {
      title: '商品管理',
      queryCondition: '查询条件',
      productInfo: '商品信息',
      productId: '商品ID',
      productImage: '商品图片',
      productGroup: '商品分组',
      productName: '商品名称',
      warehouse: '仓库',
      sales: '销量',
      stock: '库存',
      price: '价格',
      sort: '排序',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      delete: '删除',
      label: '打标',
      detail: '详情',
      addProduct: '添加商品',
      export: '导出',
      search: '查询',
      reset: '重置',
      confirmDelete: '确认删除',
      deleteContent: '确定删除该商品吗？',
      cancel: '取消',
      confirm: '确定'
    },
    productLabel: {
      title: '商品打标',
      selectLabel: '选择标签',
      save: '保存'
    },
    productSpec: {
      title: '商品规格',
      specId: '规格ID',
      specName: '规格名称',
      select: '选择',
      searchPlaceholder: '输入规格名称'
    }
  }
}